import React, { Component, useState } from "react";
import {

    NavbarBrand,

    NavItem,
    a,
} from "reactstrap";
import { Link, useLocation, Redirect } from "react-router-dom";
import "./NavMenu.css"
import { useEffect } from "react";
import axios from "axios";
export const NavMenu = (props) => {
    let menu, menuSection, menuArrow, menuClosed, menuToggle, menuOverlay;
    const [isActive, setActive] = useState(false);
    const [route, setRoute] = useState("");
    const [IsLogin, setLogin] = useState(false);
    const [IsHideDash, setDeshBoard] = useState(true);
    const [IsHideWithAff, setHideWithAff] = useState(true);
    const [UserID, setUserID] = useState(0);
    const [classVal, setClassVal] = useState("");
    const [UserData, setUserData] = useState("");
    useEffect(() => {
        setActive(false)
    }, [Location])

  
    // useEffect(() => {

    //   let url = new URLSearchParams(window.location.search);

    //   if (url.has("user") || window.localStorage.getItem("token") !== null) {
    //       let Token = {
    //           token: url.get("user") !== null ? url.get("user") : JSON.parse(window.localStorage.getItem("token")).token
    //       }
    //       url.get("user") !== null && window.localStorage.setItem("token", JSON.stringify(Token));
    //       GetUserInfo(Token.token);
    //   }
    // }, []);

    const [scroll, setScroll] = useState(false)
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 10)
        })
    },
        []);
    useEffect(() => {
        let url = window.location.href;
        url = url?.toLowerCase();

        if ((url.includes("/lp/investmentplan") || url.includes("/lp/investment-hdfc-plan") || url.includes("/lp/landingpage-thankyou") || url.includes("/lp/investment-bajaj-plan2") || url.includes("/lp/investment-bajaj-plan"))) {
            setClassVal("LandingPage");
        }
        if ((url.includes("/lp/investment-meeting-session"))) {
            setClassVal("LandingPage");

            
        }
    }, [])
    return (
        <React.Fragment>
            <header className={scroll ? `header scrolled ${classVal}`  : `header ${classVal}` }>
                <nav className="navbar navbar-expand-lg navbar-light" aria-label="Offcanvas navbar large">
                    <div className="container-fluid d-block">
                        <div className="wrapper">
                            <div className="header-item-left">
                                <a className="navbar-brand" href="/">
                                    <img src="https://www.smcinsurance.com/img/smclogo.png" alt="logo" title="SMC Insurance" />
                                </a>
                            </div>

                            <div className="header-item-center">
                                <div className="offcanvas offcanvas-start text-bg-light" tabIndex="-1" id="offcanvasNavbar2" aria-labelledby="offcanvasNavbar2Label">
                                    <div className="offcanvas-header">
                                        <a className="navbar-brand" href="/">
                                            <img src="https://www.smcinsurance.com/img/smclogo.png" alt="logo" title="SMC Insurance" />
                                        </a>
                                        <button type="button" className="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    </div>
                                    <div className="offcanvas-body">
                                        <ul className="navbar-nav flex-grow-1 pe-3">
                                            <li className="nav-item dropdown">
                                                <a className="nav-link dropdown-toggle" href="*" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    General Insurance <i className="fas fa-angle-down"></i>
                                                </a>
                                                <div className="menu-subs dropdown-menu menu-small">
                                                    <div className="OurProduct">
                                                        <ul>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/motor-insurance">
                                                                    Motor Insurance 
                                                                </a>
                                                            </li>

                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/motor-insurance/car-insurance">
                                                                    Car Insurance
                                                                </a>
                                                            </li>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/motor-insurance/two-wheeler-insurance">
                                                                    Two Wheeler Insurance
                                                                </a>
                                                            </li>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/commercial-vehical-insurance">
                                                                    Commecial Vehicle Insurance
                                                                </a>
                                                            </li>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="motor-insurance/two-wheeler-insurance/e-bike-insurance">
                                                                    E-Bike Insurance
                                                                </a>
                                                            </li>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/health-insurance">
                                                                    Health Insurance 
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>

                                            <li className="nav-item dropdown">
                                                <a className="nav-link dropdown-toggle" href="*" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Other Insurance <i className="fas fa-angle-down"></i>
                                                </a>
                                                <div className="menu-subs dropdown-menu menu-small">
                                                    <div className="OurProduct">
                                                        <ul>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/general-insurance">
                                                                    General Insurance
                                                                </a>
                                                            </li>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/term-insurance-renewal">
                                                                    Term Insurance Renewal
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>

                                            <li className="nav-item dropdown">
                                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Insurance Article <i className="fas fa-angle-down"></i>
                                                </a>
                                                <div className="menu-subs dropdown-menu menu-small">
                                                    <div className="OurProduct">
                                                        <ul>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/articles">
                                                                    Articles
                                                                </a>
                                                            </li>
                                                            <li itemProp="name">
                                                                <a itemProp="url" href="/insurance-videos">
                                                                    Videos
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>


                                        </ul>

                                        {UserID !== 31852 ?
                                            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                                                <li itemProp="name">
                                                    <a itemProp="url" href="/about" className="nav-link">
                                                        About Us
                                                    </a>
                                                </li>
                                                <li itemProp="name">
                                                    <a itemProp="url" href="/contact" className="nav-link">
                                                        Contact Us
                                                    </a>
                                                </li>
                                                <li itemProp="name">
                                                    <a itemProp="url" href="/epartner" className="nav-link">
                                                        Become a Sales Partner
                                                    </a>
                                                </li>
                                                <li itemProp="name">
                                                    <a itemProp="url" href="/claims" className="nav-link">
                                                        Claim
                                                    </a>
                                                </li>
                                                <li itemProp="name">
                                                    <a itemProp="url" href="https://ha.smcinsurance.com/" rel="nofollow" target="_blank" className="nav-link">
                                                        SMC Assure
                                                    </a>
                                                </li>
                                            </ul>
                                            :
                                            null
                                            }
                                    </div>
                                </div>
                            </div>
                            <div className="header-item-right">
                                <ul className="SubHead_Risk">
                                    {IsHideDash ?
                                        <li>
                                            <button className={`btn SMCSmall  LoginBtn NotMobile ${IsLogin ? "DashboardBtn" : ""}`} onClick={() => window.location.href = "https://www.smcinsurance.com/myaccount"}>
                                                {!IsLogin ? "Login" : /*`${UserData.userName.trim().split(" ")[0]}`*/ "Dashboard"}
                                            </button>
                                            <button className={`btn SMCSmall  LoginBtn ForMobile ${IsLogin ? "DashboardBtn" : ""}`} onClick={() => window.location.href = "https://www.smcinsurance.com/myaccount"}>
                                                {IsLogin ? <i className="fas fa-user-circle"></i> : <i className="far fa-user-circle"></i>}
                                            </button>
                                        </li>
                                        :
                                        null

                                    }

                                </ul>
                                <button className="navbar-toggler MobileNavBTN" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

        </React.Fragment>
    );
}

